import React, {useEffect, useMemo, useState} from 'react';
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/styles";
import {ActTable} from "../../components/ActTable/ActTable";
import {batch, useDispatch, useSelector} from "react-redux";
import { useDialog } from "../../hooks/useDialog";
import { Dialog } from "../../components/Dialog/Dialog";
import { useFormik } from "formik";
import Loader from "../../components/Loader/Loader";
import { DynamicFieldComponent } from "../../components/DynamicFieldComponent/DynamicFieldComponent";
import {
    getActiveEnvironmentState,
    getTableTemplate,
    loadingActiveEnvironmentState,
    loadTableTemplate,
} from "../../redux/reducers/master-of-acts-reducer";
import {loadingHandbook} from '../../redux/reducers/handbook-reducer';
import {createColumns, createRows} from "../../utils/table";
import {Button, Paper} from "@material-ui/core";
import {getProjects} from "../../redux/reducers/project-reducer";
import {cleanHashinfo, deleteActs, downloadActFile,  getActs, getInfoAct, loadActs, setSelectedAct} from "../../redux/reducers/act-reducer";
import {clearActTemplate, loadingActTemplate} from "../../redux/reducers/act-template-reducer";
import {NotificationContainer} from "../NotificationContainer/NotificationContainer";
import {createWarningNotification} from "../../redux/reducers/notification-reducer";
import {selectContracts} from "../../redux/reducers/contract-reducer";
import {CreateActButton} from "../../components/CreateActButton/CreateActButton";
import StatusButtonGroup from "../StatusButtonGroup/StatusButtonGroup.jsx";
import {getProfile} from "../../redux/reducers/user-profile-reducer.js";
import {RouteNames} from "../../router/consts";
import {UserRoles} from "../../utils/roles";
import {useRedirect} from "../../hooks/useRedirect";
import { getLoggedIn } from '../../redux/reducers/login-reducer';
import {MasterOfActsAPI} from "../../api/api";
import {downloadFile} from "../../utils/files";
import {uploadFields}  from "../UploadAnalysis/uploadFields.js";
import PivotTableComponent from '../../components/DynamicFieldComponent/uploads/DragAndDropFilesUpload/PivotTable.jsx';


const useStyles = makeStyles(theme => (
        {
            otchet: {
                color: '#0A8100',
                border: '5px solid #0A8100',
                marginLeft:'10px'
            },
            analysis:{
                marginLeft:'10px'

            },
            actPickerControlForm: {
                minWidth: '200px'
            },
            addAct: {
                color: '#0A8100',
                border: '1px solid #0A8100'
            },
            table: {
                width: '100%',
                height: '94%',
                marginTop: theme.spacing(2)
            },
            selectOutlined: {
                padding: '8.5px 35px 8.5px 10px'
            }
        }
    )
)


export const ActList = () => {
    const classes = useStyles()
    const { open, handleClose, handleOpen } = useDialog();
    const {redirect} = useRedirect()
    const formik = useFormik({
    enableReinitialize: true,
    initialValues: null,
    validationSchema: null,
  });
    const isLoggedIn = useSelector(getLoggedIn);
    const infoAct = useSelector(getInfoAct)
    const getDynamicFieldKey = (id) => `${id}-dynamic-field`;
    const {contracts, loading: contractLoading} = useSelector(selectContracts)
    const {projects, selectedProject, loading: projectLoading} = useSelector(getProjects)
    // console.log(selectedProject.id,"selectedProject");
    
    const tableTemplate = useSelector(getTableTemplate)
    const {acts, loading: loadingActs} = useSelector(getActs)
    const activeEnvironmentState = useSelector(getActiveEnvironmentState)
    const {user} = useSelector(getProfile)

    const dispatch = useDispatch()

    const columns = useMemo(() => createColumns(tableTemplate?.content?.columns,
        false),
        [tableTemplate])
    const rows = useMemo(() => createRows(acts, false),
        [acts])
    
    const [loadExcelReportButton, setLoadExcelReportButton] = useState(false)    
    const [page1, setPage1] = useState(false)    
    const [page2, setPage2] = useState(false)        

    useEffect(() => {
        if (selectedProject?.id) {
            dispatch(loadTableTemplate(selectedProject.id))
            dispatch(loadActs(selectedProject.id))
            dispatch(loadingActiveEnvironmentState(selectedProject.id))
        }
    }, [dispatch, selectedProject])

    useEffect(() => {
        if (activeEnvironmentState) {
            dispatch(loadingActTemplate(activeEnvironmentState.act_template))
            dispatch(loadingHandbook(activeEnvironmentState.handbook))
        }
    }, [activeEnvironmentState])

    useEffect(() => {
        if (!contractLoading && contracts.length === 0) {
            dispatch(createWarningNotification('Нет доступных проектов'))
        }
    }, [projects, projectLoading])

    useEffect(() => {
        if (!projectLoading && projects.length === 0) {
            dispatch(createWarningNotification('Нет доступных справочников'))
        }
    }, [projects, projectLoading])

    const handleAddActButton = async () => {
        dispatch(setSelectedAct(null))
        redirect(RouteNames.CREATE_ACT)
    }

    const onDeleteActs = (actIds) => {
        dispatch(deleteActs(actIds))
    }

    const onActClick = async (e) => {
        await batch(() => {
            dispatch(setSelectedAct(null))
            dispatch(clearActTemplate())
        })
        const actId = e.row.id
        redirect(RouteNames.ACT, {actId})
    }
    const download = async () => {
        await dispatch(downloadActFile(infoAct.id))
    }


    return <>
        <Grid container direction={'row'} alignItems={'center'} spacing={3}>
            <Grid item xs container direction={'row'} alignItems={'center'}>
                <CreateActButton onClick={handleAddActButton}
                                 disabled={loadingActs || contractLoading || projectLoading || !selectedProject}
                                 hidden={user && (!user.is_staff && user.role !== UserRoles.SUPERVISOR && user.role !== UserRoles.FIELD_CONTRACTOR)}/>
                {
                    (user?.is_staff  || user?.role !== UserRoles.PROJECT_MANAGER)?
                    <Button 
                                      onClick={async ()=>{setLoadExcelReportButton(true);setTimeout(() => {  setLoadExcelReportButton(false) }, 6000); downloadFile(MasterOfActsAPI.downloadExcelReport(selectedProject.id))} }
                                      variant="outlined"
                                      classes={{outlined: classes.otchet}}
                                      disabled={loadExcelReportButton}
                                      size={'large'}
                              > Скачать отчет
                                      </Button> :null
                }
                {(user?.is_staff  || user?.role !== UserRoles.PROJECT_MANAGER)?
                    <Button
                    onClick={()=>{
                        handleOpen();
                        setPage1(true)
                        setPage2(false)
                    }
                    }
                    classes={{outlined: classes.analysis}}
                    variant="outlined"
                    size={'small'}
                    >
                        Загрузить суточный отчет для аналитики
                    </Button>:null
                }
                {(user?.is_staff  || user?.role !== UserRoles.PROJECT_MANAGER)?
                    <Button
                    onClick={()=>
                        {
                            handleOpen();
                            setPage1(false)
                            setPage2(true)
                        }}
                    classes={{outlined: classes.analysis}}
                    variant="outlined"
                    size={'small'}
                    >
                        Сводная аналитика
                    </Button>:null
                }
            </Grid>
            <Grid item>
                <StatusButtonGroup/>
            </Grid>
        </Grid>
        <Paper className={classes.table}>
            {columns?.length > 0 && rows ?
                <ActTable rows={!(loadingActs || contractLoading || projectLoading || !selectedProject) ? rows : []}
                          columns={columns}
                          onDeleteRows={onDeleteActs}
                          onRowDoubleClick={onActClick}
                          loading={loadingActs || contractLoading || projectLoading || !selectedProject}/> :
                <Grid container
                      justifyContent={'center'}
                      alignItems={'center'}
                      style={{height: '100%'}}>
                    <Grid item>Нет шаблона таблицы</Grid>
                </Grid>}
                {page1 && open ? (
          <Dialog
            open={open}
            handleClose={() => {handleClose()}}
            title="Загрузка суточного рапорта для обработки"
            fullWidth
            maxWidth={"md"}
          >
            {(user?.is_staff  || user?.role !== UserRoles.PROJECT_MANAGER)?(
              <>
                <Grid container spacing={1} direction={"column"}>

                  {uploadFields?.map((field) => (
                    <Grid item key={getDynamicFieldKey(field.id)}>
                      <DynamicFieldComponent
                        {...field}
                        {...formik.getFieldProps(field.variable)}
                        touched={formik.touched[field.variable]}
                        error={formik.errors[field.variable]}
                        setFieldValue={formik.setFieldValue}
                      />
                    </Grid>
                  ))}
                  
                </Grid>
                <Grid
                  item
                  style={{
                    marginTop: 15,
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  
                </Grid>
              </>
            ) : (
              <Loader />
            )}
          </Dialog>
        ) : null}
        {page2 && open ? (
          <Dialog
            open={open}
            handleClose={() => {handleClose()}}
            title="Сводная таблица"
            fullWidth
            maxWidth={"xl"}
          >

            {(user?.is_staff  || user?.role !== UserRoles.PROJECT_MANAGER)?(

              <>
                <Grid container spacing={1} direction={"column"}>
{
    <PivotTableComponent ></PivotTableComponent>

}
                  
                </Grid>
              </>
            ) : (
              <Loader />
            )}
          </Dialog>
        ) : null}
                
        </Paper>
        <NotificationContainer/>
    </>
}